const DeleteModal = ({ closeModal, deletePost, text = "Post", deleting }) => (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-customGray p-6 rounded-lg shadow-lg w-80">
            <h2 className="text-lg text-white font-semibold">Delete {text} </h2>
            <p className="text-white mt-2">Are you sure you want to Delete this {text}? This action cannot be undone.</p>
            <div className="flex justify-end mt-4 space-x-2">
                <button
                    className="px-4 py-2 text-white hover:text-customGray border rounded-md hover:bg-gray-100"
                    onClick={closeModal}
                >
                    Cancel
                </button>
                <button
                    disabled={deleting}
                    className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={deletePost}
                >
                    {deleting ? "Deleting..." : `Delete ${text}`}
                </button>
            </div>
        </div>
    </div>
)

export default DeleteModal